import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../Home/Home";
import TermsCondition from "../TermsCondition/TermsCondition";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";
import About from "../About/About";
import WeWorks from "../WeWorks/WeWorks";

export default function Router() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/termsCondition" element={<TermsCondition />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          {/* <Route path="/aboutUs" element={<About />} /> */}
          {/* <Route path="/weWorks" element={<WeWorks />} /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}
